import React, { useState } from "react";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Button, message, Modal, Spin, Table } from "antd";
import {
  useDeleteNewsMutation,
  useGetAllNewsQuery,
} from "../../../redux/Service/api";
import AddNews from "./AddNews";
import EditNews from "./EditNews";
import ServerError from "../../../Components/utils/ServerError";
import Heading from "../../../Components/Heading/Heading";

const { confirm } = Modal;

function NewsSettings() {
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [articleIdForEdit, setArticleIdForEdit] = useState(null);
  const [rerenderEditKey, setRerenderEditKey] = useState(0);

  const {
    data: allNewsData,
    isError: isAllNewsError,
    isLoading: isAllNewsLoading,
  } = useGetAllNewsQuery();

  const allNews = allNewsData?.data ?? [];

  const [deleteNews, { isLoading: delIsLoading }] = useDeleteNewsMutation();

  const handleDeleteNews = async (id) => {
    confirm({
      title: "هل تريد حذف هذا الخبر؟",
      icon: <ExclamationCircleOutlined />,
      content: "سيتم حذف الخبر عند الضغط على زر موافق.",
      async onOk() {
        try {
          const res = await deleteNews(id);
          res.data.message
            ? message.info(res.data.message)
            : message.success("تم حذف الخبر بنجاح");
        } catch (error) {
          console.error(error);
          message.error("فشل في حذف الخبر.");
        }
      },
    });
  };

  const columns = [
    {
      title: "الصورة",
      dataIndex: "photo",
      key: "photo",
      render: (photo) => (
        <img src={photo} alt="news" className="w-24 h-16 object-cover" />
      ),
    },
    {
      title: "العنوان",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "المحتوى",
      dataIndex: "content",
      key: "content",
      ellipsis: true,
    },
    {
      title: "الإجراءات",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-4 space-x-reverse">
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteNews(record.id)}
          >
            حذف
          </Button>
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              setOpenEditModal(true);
              setArticleIdForEdit(record.id);
              setRerenderEditKey((prev) => prev + 1);
            }}
          >
            تعديل
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="gap-3 relative p-4" dir="rtl">
      <Heading heading="الأخبار" />

      {isAllNewsError && <ServerError />}

      <div className="text-center my-3">
        <Button
          className="w-[150px]"
          type="primary"
          onClick={() => setOpenAddModal(true)}
        >
          إضافة سلايدر
        </Button>
      </div>

      <Table
        dataSource={allNews}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 5 }}
        loading={isAllNewsLoading}
        className="bg-white shadow-md rounded-lg"
      />

      <EditNews
        setOpenEditModal={setOpenEditModal}
        openEditModal={openEditModal}
        articleIdForEdit={articleIdForEdit}
        rerenderEditKey={rerenderEditKey}
      />

      <AddNews setOpenAddModal={setOpenAddModal} openAddModal={openAddModal} />
    </div>
  );
}

export default NewsSettings;
